import { Link } from "react-router";
import markUrl from "@/assets/king-terrier-mark-64.jpeg";
import { site } from "@/lib/site";

/**
 * The nav logotype: the 26px mark plus the wordmark, linking home.
 *
 * The mark is a JPEG with a cobalt background baked in, hidden by blending it against
 * the identical cobalt page ground. That means nothing between this image and <body>
 * may create a stacking context (transform, opacity < 1, filter, isolation) or the
 * blend backdrop changes and the square reappears. Goes away once the handoff's open
 * item -- a transparent SVG export of the mark -- lands.
 */
export function BrandMark() {
    return (
        <Link to="/" className="flex items-center gap-[11px]">
            <span className="block size-6.5 shrink-0 overflow-hidden">
                <img
                    src={markUrl}
                    alt=""
                    width={26}
                    height={26}
                    className="block w-full mix-blend-lighten"
                />
            </span>
            <span className="text-[13px] font-medium uppercase tracking-caps text-kt-brand">
                {site.name}
            </span>
        </Link>
    );
}
